import { Grid, styled, Typography as TypographyBase } from '@mui/material'

export const Wrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',

  '& p': {
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
  },

  '& svg': {
    [theme.breakpoints.down('md')]: {
      fontSize: 20,
    },
  },

  '& .MuiSelect-select': {
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
      padding: '8px -1px',
    },
  },
}))

export const Typography = styled(TypographyBase)(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const Label = styled(TypographyBase)(({ theme }) => ({
  marginRight: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}))
